/**
 * TS bridge to the custom Android `OverlayBridge` Capacitor plugin.
 *
 * Native Java lives at `capacitor-plugins/overlay-bridge/android/...` and
 * is auto-registered by Capacitor on `npx cap sync android` via the
 * `file:` dependency in root package.json. We re-register the plugin name
 * here through `@capacitor/core` so Vite never has to resolve the local
 * plugin's JS entry — same pattern as device-flags.
 */
import { registerPlugin, type PluginListenerHandle } from '@capacitor/core';

export interface OfferActionEvent {
  action: 'accept' | 'reject' | 'dismiss';
  request_id: string;
}

export interface OverlayBridgePlugin {
  /**
   * Marks the in-app React trip-offer overlay as visible (or hidden). When
   * `active=true`, the native FcmReceiver SKIPS launching the full-screen
   * TripOfferActivity for incoming `trip_offer` pushes — the in-app overlay
   * is already handling them. Android-only; no-op elsewhere.
   */
  setOverlayActive(options: { active: boolean }): Promise<void>;

  /**
   * Fires when the driver taps Accept / Decline in the NATIVE full-screen
   * TripOfferActivity (popup over lock-screen / other apps).
   */
  addListener(
    eventName: 'offerAction',
    listenerFunc: (event: OfferActionEvent) => void,
  ): Promise<PluginListenerHandle>;
}

export const OverlayBridge = registerPlugin<OverlayBridgePlugin>('OverlayBridge');